var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import * as React from "react";
import React__default, { createRef, memo, useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
var Version = /* @__PURE__ */ ((Version2) => {
  Version2["v201912"] = "v201912";
  Version2["v201805"] = "v201805";
  Version2["v201804"] = "v201804";
  return Version2;
})(Version || {});
const _AppContext = class _AppContext {
  constructor() {
    __publicField(this, "version", Version.v201804);
    __publicField(this, "containerId", null);
    __publicField(this, "dock", createRef());
  }
  get container() {
    return document.getElementById(this.containerId);
  }
  static get current() {
    return _AppContext.__instance;
  }
  static init(version) {
    if (_AppContext.__instance instanceof _AppContext && typeof _AppContext.__instance !== "undefined") {
      return _AppContext.__instance;
    }
    _AppContext.__instance = new _AppContext();
    _AppContext.__instance.version = version;
    return _AppContext.__instance;
  }
};
__publicField(_AppContext, "__instance");
let AppContext = _AppContext;
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = "";
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames2.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const defaultDockClassName = "pncf-preview-dock";
const PreviewDock = (props) => {
  const classes = props.classNames;
  if (!classes.includes(defaultDockClassName)) {
    classes.unshift(defaultDockClassName);
  }
  return AppContext.current ? /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: AppContext.current.dock,
      id: `pncf-${AppContext.current.version}`,
      className: classNames(classes)
    },
    props.children
  ) : /* @__PURE__ */ React__default.createElement("div", { className: classNames(classes) }, props.children);
};
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["MAC_OS"] = "mac_os";
  Platform2["WINDOWS"] = "windows";
  Platform2["IOS"] = "ios";
  Platform2["ANDROID"] = "android";
  Platform2["NATIVE_ANDROID"] = "native_android";
  return Platform2;
})(Platform || {});
var Browser = /* @__PURE__ */ ((Browser2) => {
  Browser2["CHROME"] = "chrome";
  Browser2["FIREFOX"] = "firefox";
  Browser2["SAFARI"] = "safari";
  Browser2["EDGE"] = "edge";
  return Browser2;
})(Browser || {});
class Notification {
  constructor(fields) {
    __publicField(this, "title", "Notification Title");
    __publicField(this, "subtitle");
    __publicField(this, "body");
    __publicField(this, "domain", "pushly.com");
    __publicField(this, "badge");
    __publicField(this, "icon");
    __publicField(this, "image");
    __publicField(this, "actions");
    __publicField(this, "badgeColor");
    __publicField(this, "useImageForIconWhenPresent");
    if (fields) {
      Object.keys(fields).forEach((prop) => {
        const value = fields[prop];
        if (!value || typeof value === "undefined" || String(value).trim() == "") {
          delete fields[prop];
        }
      });
      Object.assign(this, fields);
    }
  }
}
class BaseError {
  constructor(...args) {
    Error.apply(this, args);
  }
}
class UnsupportedPlatformError extends BaseError {
  constructor() {
    super();
    __publicField(this, "message", "Platform is not supported");
    console.warn(this.message);
  }
}
class UnsupportedBrowserError extends BaseError {
  constructor() {
    super();
    __publicField(this, "message", "Browser is not supported");
    console.warn(this.message);
  }
}
class UnsupportedPlatformBrowserError extends BaseError {
  constructor() {
    super();
    __publicField(this, "message", "Browser is not supported on specified platform");
    console.warn(this.message);
  }
}
var PreviewState = /* @__PURE__ */ ((PreviewState2) => {
  PreviewState2["COLLAPSED"] = "collapsed";
  PreviewState2["EXPANDED"] = "expanded";
  return PreviewState2;
})(PreviewState || {});
class PreviewConfig {
  constructor(fields) {
    __publicField(this, "loading", false);
    __publicField(this, "platform", Platform.MAC_OS);
    __publicField(this, "state", PreviewState.COLLAPSED);
    __publicField(this, "browser", Browser.CHROME);
    __publicField(this, "chromeless", false);
    __publicField(this, "appName");
    __publicField(this, "notification", null);
    __publicField(this, "animated", false);
    __publicField(this, "loggingEnabled", false);
    __publicField(this, "useEnv", false);
    __publicField(this, "systemMode", "light");
    if (fields) {
      const _a = fields, { notification } = _a, otherFields = __objRest(_a, ["notification"]);
      Object.assign(this, __spreadProps(__spreadValues({}, otherFields), {
        notification: new Notification(notification)
      }));
    }
  }
  validate() {
    if (Object.values(Platform).indexOf(this.platform) === -1) {
      throw new UnsupportedPlatformError();
    }
    if (Object.values(Browser).indexOf(this.browser) === -1) {
      throw new UnsupportedBrowserError();
    }
    if ([Platform.MAC_OS, Platform.ANDROID].indexOf(this.platform) !== -1 && this.browser == Browser.EDGE) {
      throw new UnsupportedPlatformBrowserError();
    }
  }
}
const googleChromeLogo = "data:image/png;base64,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";
const BrowserIcon = {
  // chrome: 'https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/chrome/chrome.svg',
  chrome: googleChromeLogo,
  safari: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/safari/safari.png",
  safari_ios: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/safari-ios/safari-ios.svg",
  firefox: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/firefox/firefox.svg",
  edge: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/edge/edge.svg",
  edge_tile: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/edge-tile/edge-tile.svg",
  ie: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/45.5.0/archive/internet-explorer_9-11/internet-explorer_9-11.svg"
};
Object.freeze(BrowserIcon);
const WifiSvg = memo((props) => {
  const isApple = props.env === Platform.IOS || props.env === Platform.MAC_OS;
  return isApple ? /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      className: props.className,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "17.9896",
      height: "12.9922",
      stroke: "currentColor"
    },
    /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("rect", { height: "12.9922", opacity: "0", width: "17.9896", x: "0", y: "0" }), /* @__PURE__ */ React__default.createElement(
      "path",
      {
        d: "M8.99338 12.9922C9.16525 12.9922 9.31369 12.9141 9.61838 12.6172L11.5246\n                    10.7891C11.6418 10.6719 11.6731 10.5 11.5637 10.3594C11.0559 9.70312 10.0949\n                    9.13281 8.99338 9.13281C7.86056 9.13281 6.89963 9.72656 6.39181 10.4062C6.31369\n                    10.5312 6.34494 10.6719 6.46994 10.7891L8.36838 12.6172C8.67306 12.9062 8.8215\n                    12.9922 8.99338 12.9922ZM4.42306 8.74219C4.59494 8.90625 4.80588 8.88281 4.96213\n                    8.71094C5.89963 7.67188 7.43088 6.91406 8.99338 6.92188C10.5715 6.91406 12.1028\n                    7.69531 13.0559 8.73438C13.1965 8.89844 13.3918 8.89062 13.5637 8.73438L14.7746\n                    7.53125C14.8996 7.40625 14.9153 7.23438 14.7981 7.09375C13.6184 5.64844 11.4309\n                    4.5625 8.99338 4.5625C6.55588 4.5625 4.36838 5.64844 3.18869 7.09375C3.0715 7.23438\n                    3.07931 7.39062 3.21213 7.53125ZM1.18088 5.47656C1.33713 5.625 1.55588 5.625 1.70431\n                    5.46875C3.62619 3.42969 6.15744 2.35156 8.99338 2.35156C11.8449 2.35156 14.3918 3.4375\n                    16.2981 5.47656C16.4387 5.61719 16.6496 5.60938 16.8059 5.46094L17.884 4.38281C18.0246\n                    4.24219 18.0168 4.07031 17.9074 3.9375C16.0715 1.67188 12.6184 0.0078125 8.99338 0.0078125C5.37619\n                    0.0078125 1.90744 1.67188 0.0793145 3.9375C-0.0300605 4.07031-0.0300605 4.24219 0.102752 4.38281Z",
        fillOpacity: "1"
      }
    ))
  ) : /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: props.className
    },
    /* @__PURE__ */ React__default.createElement("path", { d: "M5 12.55a11 11 0 0 1 14.08 0" }),
    /* @__PURE__ */ React__default.createElement("path", { d: "M1.42 9a16 16 0 0 1 21.16 0" }),
    /* @__PURE__ */ React__default.createElement("path", { d: "M8.53 16.11a6 6 0 0 1 6.95 0" }),
    /* @__PURE__ */ React__default.createElement("line", { x1: "12", y1: "20", x2: "12.01", y2: "20" })
  );
});
const ContactIcon = memo((props) => {
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      className: props.className,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "15.9375",
      height: "15.9453"
    },
    /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("rect", { height: "15.9453", opacity: "0", width: "15.9375", x: "0", y: "0" }), /* @__PURE__ */ React__default.createElement("path", { d: "M7.96875 15.9375C12.3281 15.9375 15.9375 12.3203 15.9375 7.96875C15.9375 3.60938 12.3203 0 7.96094 0C3.60938 0 0 3.60938 0 7.96875C0 12.3203 3.61719 15.9375 7.96875 15.9375ZM7.96875 14.6094C4.28125 14.6094 1.33594 11.6562 1.33594 7.96875C1.33594 4.28125 4.27344 1.32812 7.96094 1.32812C11.6484 1.32812 14.6094 4.28125 14.6094 7.96875C14.6094 11.6562 11.6562 14.6094 7.96875 14.6094ZM13.3125 13.1172L13.2891 13.0312C12.9062 11.8828 10.8438 10.625 7.96875 10.625C5.10156 10.625 3.03906 11.8828 2.64844 13.0234L2.625 13.1172C4.03125 14.5078 6.44531 15.3203 7.96875 15.3203C9.5 15.3203 11.8906 14.5156 13.3125 13.1172ZM7.96875 9.29688C9.47656 9.3125 10.6484 8.03125 10.6484 6.35156C10.6484 4.77344 9.46875 3.46875 7.96875 3.46875C6.46875 3.46875 5.28125 4.77344 5.28906 6.35156C5.29688 8.03125 6.46875 9.28125 7.96875 9.29688Z", fill: "#000000", fillOpacity: "0.85" }))
  );
});
const MagnifyIcon = memo((props) => {
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      className: props.className,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "15.2656",
      height: "15.4141"
    },
    /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("rect", { height: "15.4141", opacity: "0", width: "15.2656", x: "0", y: "0" }), /* @__PURE__ */ React__default.createElement("path", { d: "M0 6.23438C0 9.67188 2.79688 12.4688 6.23438 12.4688C7.59375 12.4688 8.83594 12.0312 9.85938 11.2969L13.7031 15.1484C13.8828 15.3281 14.1172 15.4141 14.3672 15.4141C14.8984 15.4141 15.2656 15.0156 15.2656 14.4922C15.2656 14.2422 15.1719 14.0156 15.0078 13.8516L11.1875 10.0078C11.9922 8.96094 12.4688 7.65625 12.4688 6.23438C12.4688 2.79688 9.67188 0 6.23438 0C2.79688 0 0 2.79688 0 6.23438ZM1.33594 6.23438C1.33594 3.53125 3.53125 1.33594 6.23438 1.33594C8.9375 1.33594 11.1328 3.53125 11.1328 6.23438C11.1328 8.9375 8.9375 11.1328 6.23438 11.1328C3.53125 11.1328 1.33594 8.9375 1.33594 6.23438Z", fill: "#000000", fillOpacity: "0.85" }))
  );
});
function getPreferredColorScheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
let defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(date, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const weekStartsOn = (_h = (_g = (_d = (_c = options == null ? void 0 : options.weekStartsOn) != null ? _c : (_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.weekStartsOn) != null ? _d : defaultOptions2.weekStartsOn) != null ? _g : (_f = (_e = defaultOptions2.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.weekStartsOn) != null ? _h : 0;
  const _date = toDate(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}
function getISOWeekYear(date) {
  const _date = toDate(date);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfDay(date) {
  const _date = toDate(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date) {
  const _date = toDate(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function startOfISOWeekYear(date) {
  const year = getISOWeekYear(date);
  const fourthOfJanuary = constructFrom(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function isDate(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date) {
  if (!isDate(date) && typeof date !== "number") {
    return false;
  }
  const _date = toDate(date);
  return !isNaN(Number(_date));
}
function startOfYear(date) {
  const cleanDate = toDate(date);
  const _date = constructFrom(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count, options) => {
  let result;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey(parsePatterns, (pattern) => pattern.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey(object, predicate) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult)
      return null;
    const matchedString = matchResult[0];
    const parseResult = string.match(args.parsePattern);
    if (!parseResult)
      return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear(date) {
  const _date = toDate(date);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function getISOWeek(date) {
  const _date = toDate(date);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const _date = toDate(date);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (_h = (_g = (_d = (_c = options == null ? void 0 : options.firstWeekContainsDate) != null ? _c : (_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) != null ? _d : defaultOptions2.firstWeekContainsDate) != null ? _g : (_f = (_e = defaultOptions2.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.firstWeekContainsDate) != null ? _h : 1;
  const firstWeekOfNextYear = constructFrom(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const firstWeekContainsDate = (_h = (_g = (_d = (_c = options == null ? void 0 : options.firstWeekContainsDate) != null ? _c : (_b = (_a = options == null ? void 0 : options.locale) == null ? void 0 : _a.options) == null ? void 0 : _b.firstWeekContainsDate) != null ? _d : defaultOptions2.firstWeekContainsDate) != null ? _g : (_f = (_e = defaultOptions2.locale) == null ? void 0 : _e.options) == null ? void 0 : _f.firstWeekContainsDate) != null ? _h : 1;
  const year = getWeekYear(date, options);
  const firstWeek = constructFrom(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date, options) {
  const _date = toDate(date);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}
const lightFormatters = {
  // Year
  y(date, token) {
    const signedYear = date.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },
  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },
  // Minute
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },
  // Second
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },
  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date, token, localize2) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date, token, localize2) {
    if (token === "yo") {
      const signedYear = date.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function(date, token, localize2, options) {
    const signedWeekYear = getWeekYear(date, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date, token) {
    const isoWeekYear = getISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date, token) {
    const year = date.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date, token, localize2) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date, token, localize2) {
    const month = date.getMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date, token, localize2, options) {
    const week = getWeek(date, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date, token, localize2) {
    const isoWeek = getISOWeek(date);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function(date, token, localize2) {
    const dayOfYear = getDayOfYear(date);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date, token, localize2, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date, token, localize2) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date, token, localize2) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date, token, localize2) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date, token, localize2) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function(date, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function(date, token, localize2) {
    const hours = date.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date, token, localize2) {
    let hours = date.getHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function(date, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date, token, _localize) {
    const timestamp = date.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern, formatLong2) => {
  switch (pattern) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern, formatLong2) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input) {
  const _message = message(token, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token))
    throw new RangeError(_message);
}
function message(token, format2, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const defaultOptions2 = getDefaultOptions();
  const locale = (_b = (_a = options == null ? void 0 : options.locale) != null ? _a : defaultOptions2.locale) != null ? _b : enUS;
  const firstWeekContainsDate = (_j = (_i = (_f = (_e = options == null ? void 0 : options.firstWeekContainsDate) != null ? _e : (_d = (_c = options == null ? void 0 : options.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) != null ? _f : defaultOptions2.firstWeekContainsDate) != null ? _i : (_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.firstWeekContainsDate) != null ? _j : 1;
  const weekStartsOn = (_r = (_q = (_n = (_m = options == null ? void 0 : options.weekStartsOn) != null ? _m : (_l = (_k = options == null ? void 0 : options.locale) == null ? void 0 : _k.options) == null ? void 0 : _l.weekStartsOn) != null ? _n : defaultOptions2.weekStartsOn) != null ? _q : (_p = (_o = defaultOptions2.locale) == null ? void 0 : _o.options) == null ? void 0 : _p.weekStartsOn) != null ? _r : 0;
  const originalDate = toDate(date);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale
  };
  return parts.map((part) => {
    if (!part.isToken)
      return part.value;
    const token = part.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
const MacOsTemplate = (props) => {
  var _a;
  const [actionsVisible, setActionsVisible] = useState(false);
  const [showExpandedView, setShowExpandedView] = useState(false);
  const [menuTime, setMenuTime] = useState(/* @__PURE__ */ new Date());
  const colorScheme = (_a = props.config.systemMode) != null ? _a : getPreferredColorScheme();
  const config = props.config;
  const notification = config.notification;
  const actions = notification.actions;
  const chromeless = config.chromeless;
  const SettingsAction = {
    action: "settings",
    title: "Settings"
  };
  if (actions && !actions.find((action) => action.action === "settings")) {
    actions.push(SettingsAction);
  }
  let icon = notification.icon;
  let hasImage = "";
  if (icon) {
    icon = encodeURI(icon);
    hasImage = "hasImage";
  }
  const assignColorScheme = (classnames2) => {
    return `${classnames2} ${colorScheme}`;
  };
  const isExpandedView = config.state === PreviewState.EXPANDED;
  setInterval(() => setMenuTime(/* @__PURE__ */ new Date()), 6e4);
  return /* @__PURE__ */ React__default.createElement("div", { className: assignColorScheme(`osx-env-wrapper${config.useEnv ? " active" : ""} ${isExpandedView ? "expanded" : ""}${chromeless ? " chromeless" : ""}`) }, !chromeless && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "mac-device-outline-wrapper" }), /* @__PURE__ */ React__default.createElement("div", { className: "mac-menu-bar" }, /* @__PURE__ */ React__default.createElement(WifiSvg, { className: "wifi-icon" }), /* @__PURE__ */ React__default.createElement(ContactIcon, { className: "contact-icon" }), /* @__PURE__ */ React__default.createElement(MagnifyIcon, { className: "magnify-icon" }), /* @__PURE__ */ React__default.createElement("div", { className: "siri-icon" }), /* @__PURE__ */ React__default.createElement("div", { className: "mac-date" }, format(menuTime, "EEE MMM d H:mm a")))), /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: assignColorScheme(`wrapper mac-notification-wrapper${config.animated ? " animated" : ""} ${isExpandedView ? "expanded" : ""} ${hasImage}`)
    },
    isExpandedView && hasImage && /* @__PURE__ */ React__default.createElement("div", { className: `expanded-notification-header` }),
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: "left browser-icon",
        style: { backgroundImage: `url("${BrowserIcon[config.browser]}")` }
      }
    ),
    /* @__PURE__ */ React__default.createElement("div", { className: `${notification.image ? "notification-message" : "short notification-message"} ${isExpandedView ? "expanded" : ""} ${hasImage}` }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-message-top" }, notification.title), /* @__PURE__ */ React__default.createElement("div", { className: "notification-message-middle" }, notification.domain), /* @__PURE__ */ React__default.createElement("div", { className: `notification-message-bottom${colorScheme === "dark" ? "-dark" : "-light"} ${isExpandedView ? "expanded" : ""}` }, notification.body)),
    icon && /* @__PURE__ */ React__default.createElement("div", { className: `notification-icon ${isExpandedView ? "expanded" : ""}` }, /* @__PURE__ */ React__default.createElement("img", { src: icon, alt: icon })),
    /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, /* @__PURE__ */ React__default.createElement(
      "i",
      {
        className: assignColorScheme("expand-arrow arrow-right"),
        onClick: () => setShowExpandedView(!showExpandedView)
      }
    ))),
    actions && /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: assignColorScheme("right-btn") }, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: assignColorScheme("options"),
        onClick: () => setActionsVisible(!actionsVisible)
      },
      /* @__PURE__ */ React__default.createElement("span", null, "Options ", /* @__PURE__ */ React__default.createElement("i", { className: "arrow down" }))
    )), /* @__PURE__ */ React__default.createElement("div", { className: assignColorScheme(`actions-wrapper ${isExpandedView ? "expanded" : ""}`) }, /* @__PURE__ */ React__default.createElement("ul", null, actions == null ? void 0 : actions.map((action, idx) => /* @__PURE__ */ React__default.createElement("li", { key: idx, className: "action-btn" }, /* @__PURE__ */ React__default.createElement("span", { className: "action-btn-title" }, action.title)))))),
    /* @__PURE__ */ React__default.createElement("div", { className: assignColorScheme("close-mac") }, /* @__PURE__ */ React__default.createElement("span", { className: colorScheme === "dark" ? "close-icon-dark" : "close-icon-light" }))
  ));
};
class Utils {
  static toTitleCase(input) {
    return input.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
const VolumeIcon = memo((props) => {
  var _a;
  const boxSize = (_a = props.width) != null ? _a : 24;
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: boxSize,
      height: boxSize,
      viewBox: `0 0 ${boxSize} ${boxSize}`,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: props.className
    },
    /* @__PURE__ */ React__default.createElement("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }),
    /* @__PURE__ */ React__default.createElement("path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" })
  );
});
const BatteryIcon = memo((props) => {
  var _a;
  const boxSize = (_a = props.width) != null ? _a : 24;
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: boxSize,
      height: boxSize,
      viewBox: `0 0 ${boxSize} ${boxSize}`,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: props.className
    },
    /* @__PURE__ */ React__default.createElement("rect", { x: "1", y: "6", width: "18", height: "12", rx: "2", ry: "2" }),
    /* @__PURE__ */ React__default.createElement("line", { x1: "23", y1: "13", x2: "23", y2: "11" })
  );
});
const MessageSquare = memo((props) => {
  var _a;
  const boxSize = (_a = props.width) != null ? _a : 24;
  return /* @__PURE__ */ React__default.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: boxSize,
      height: boxSize,
      viewBox: `0 0 ${boxSize} ${boxSize}`,
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: props.className
    },
    /* @__PURE__ */ React__default.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
  );
});
const WindowsTemplate = (props) => {
  const config = props.config;
  const notification = config.notification;
  const actions = notification.actions;
  const browserName = Utils.toTitleCase(config.browser);
  const chromeless = config.chromeless;
  let icon = notification.icon;
  if (icon) {
    icon = encodeURI(icon);
  }
  let image = notification.image;
  if (image) {
    image = encodeURI(image);
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: `windows-env-wrapper${image ? " hasImage" : ""}${chromeless ? " chromeless" : ""}` }, !chromeless && /* @__PURE__ */ React__default.createElement("div", { className: "windows-menu-bar" }, /* @__PURE__ */ React__default.createElement(WifiSvg, { className: "windows-wifi" }), /* @__PURE__ */ React__default.createElement(BatteryIcon, { className: "windows-battery" }), /* @__PURE__ */ React__default.createElement(VolumeIcon, { className: "windows-volume" }), /* @__PURE__ */ React__default.createElement("div", { className: "windows-date" }, /* @__PURE__ */ React__default.createElement("span", { className: "time" }, format(/* @__PURE__ */ new Date(), "H:mm a")), /* @__PURE__ */ React__default.createElement("span", { className: "date" }, format(/* @__PURE__ */ new Date(), "MM/dd/yyyy"))), /* @__PURE__ */ React__default.createElement(MessageSquare, { className: "windows-msg-icon" })), /* @__PURE__ */ React__default.createElement("div", { className: `wrapper windows-notification-wrapper${config.animated ? " animated" : ""} ${image ? "hasImage" : ""}` }, image && /* @__PURE__ */ React__default.createElement("div", { className: "secondary" }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "image",
      style: { backgroundImage: `url("${image}")` }
    }
  )), /* @__PURE__ */ React__default.createElement("div", { className: "primary" }, icon && /* @__PURE__ */ React__default.createElement("div", { className: "left" }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "icon",
      style: {
        backgroundImage: `url("${icon}")`
      }
    }
  )), /* @__PURE__ */ React__default.createElement("div", { className: "right" }, /* @__PURE__ */ React__default.createElement("div", { className: "top" }, /* @__PURE__ */ React__default.createElement("span", { className: "title" }, notification.title), /* @__PURE__ */ React__default.createElement("span", { className: "close" }, "✕")), /* @__PURE__ */ React__default.createElement("div", { className: "middle" }, /* @__PURE__ */ React__default.createElement("span", { className: "body" }, notification.body)), /* @__PURE__ */ React__default.createElement("div", { className: "bottom" }, /* @__PURE__ */ React__default.createElement("span", { className: "domain" }, notification.domain, " · via ", browserName)))), !!actions && actions.length > 0 && /* @__PURE__ */ React__default.createElement("div", { className: "actions-wrapper" }, /* @__PURE__ */ React__default.createElement("ul", null, actions.map((action, idx) => /* @__PURE__ */ React__default.createElement("li", { key: idx, className: "action-btn" }, /* @__PURE__ */ React__default.createElement("span", { className: "action-btn-title" }, action.title)))))));
};
var cssUnit = {
  cm: true,
  mm: true,
  in: true,
  px: true,
  pt: true,
  pc: true,
  em: true,
  ex: true,
  ch: true,
  rem: true,
  vw: true,
  vh: true,
  vmin: true,
  vmax: true,
  "%": true
};
function parseLengthAndUnit(size) {
  if (typeof size === "number") {
    return {
      value: size,
      unit: "px"
    };
  }
  var value;
  var valueString = (size.match(/^[0-9.]*/) || "").toString();
  if (valueString.includes(".")) {
    value = parseFloat(valueString);
  } else {
    value = parseInt(valueString, 10);
  }
  var unit = (size.match(/[^0-9]*$/) || "").toString();
  if (cssUnit[unit]) {
    return {
      value,
      unit
    };
  }
  console.warn("React Spinners: ".concat(size, " is not a valid css value. Defaulting to ").concat(value, "px."));
  return {
    value,
    unit: "px"
  };
}
function cssValue(value) {
  var lengthWithunit = parseLengthAndUnit(value);
  return "".concat(lengthWithunit.value).concat(lengthWithunit.unit);
}
var createAnimation = function(loaderName, frames, suffix) {
  var animationName = "react-spinners-".concat(loaderName, "-").concat(suffix);
  if (typeof window == "undefined" || !window.document) {
    return animationName;
  }
  var styleEl = document.createElement("style");
  document.head.appendChild(styleEl);
  var styleSheet = styleEl.sheet;
  var keyFrames = "\n    @keyframes ".concat(animationName, " {\n      ").concat(frames, "\n    }\n  ");
  if (styleSheet) {
    styleSheet.insertRule(keyFrames, 0);
  }
  return animationName;
};
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
var clip = createAnimation("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");
function ClipLoader(_a) {
  var _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? "#000000" : _c, _d = _a.speedMultiplier, speedMultiplier = _d === void 0 ? 1 : _d, _e = _a.cssOverride, cssOverride = _e === void 0 ? {} : _e, _f = _a.size, size = _f === void 0 ? 35 : _f, additionalprops = __rest(_a, ["loading", "color", "speedMultiplier", "cssOverride", "size"]);
  var style = __assign({ background: "transparent !important", width: cssValue(size), height: cssValue(size), borderRadius: "100%", border: "2px solid", borderTopColor: color, borderBottomColor: "transparent", borderLeftColor: color, borderRightColor: color, display: "inline-block", animation: "".concat(clip, " ").concat(0.75 / speedMultiplier, "s 0s infinite linear"), animationFillMode: "both" }, cssOverride);
  if (!loading) {
    return null;
  }
  return React.createElement("span", __assign({ style }, additionalprops));
}
var deliveryChannels_enum = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.DeliveryChannel = void 0;
  (function(DeliveryChannel) {
    DeliveryChannel["WEB"] = "WEB";
    DeliveryChannel["NATIVE_IOS"] = "NATIVE_IOS";
    DeliveryChannel["NATIVE_ANDROID"] = "NATIVE_ANDROID";
  })(exports.DeliveryChannel || (exports.DeliveryChannel = {}));
})(deliveryChannels_enum);
var DeviceView = /* @__PURE__ */ ((DeviceView2) => {
  DeviceView2["LOCK_SCREEN"] = "LOCK_SCREEN";
  DeviceView2["HOME_SCREEN"] = "HOME_SCREEN";
  DeviceView2["IN_APP"] = "IN_APP";
  return DeviceView2;
})(DeviceView || {});
const NativeDeviceWrapper = (props) => {
  const {
    children,
    loading,
    view,
    className,
    channel,
    orientation,
    systemMode,
    useDynamicIsland
  } = props;
  const deviceView = view != null ? view : "IN_APP";
  const statusTime = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames("native-device-wrapper", className, orientation, systemMode, {
    ios: channel === deliveryChannels_enum.DeliveryChannel.NATIVE_IOS,
    android: channel === deliveryChannels_enum.DeliveryChannel.NATIVE_ANDROID,
    ["with-di"]: useDynamicIsland != null ? useDynamicIsland : true
  }) }, /* @__PURE__ */ React__default.createElement("div", { className: "screen" }, loading ? /* @__PURE__ */ React__default.createElement("div", { className: classNames("loader") }, typeof loading === "boolean" ? /* @__PURE__ */ React__default.createElement(ClipLoader, { color: "#168fd0", loading: true, size: 48 }) : loading) : children, /* @__PURE__ */ React__default.createElement("div", { className: classNames("app", deviceView.toLowerCase(), {
    loading: !!loading
  }) }, deviceView === "LOCK_SCREEN" && /* @__PURE__ */ React__default.createElement("div", { className: "lock-screen" }, /* @__PURE__ */ React__default.createElement("div", { className: "home-bar" }), /* @__PURE__ */ React__default.createElement("div", { className: "lock-button" }, /* @__PURE__ */ React__default.createElement("span", { className: "unlocked" })), /* @__PURE__ */ React__default.createElement("div", { className: "date" }, /* @__PURE__ */ React__default.createElement("span", null, format(statusTime, "eeee, LLLL d"))), /* @__PURE__ */ React__default.createElement("div", { className: "time" }, /* @__PURE__ */ React__default.createElement("span", null, format(statusTime, "H:mm")))), /* @__PURE__ */ React__default.createElement("div", { className: "nav-bar top" }, /* @__PURE__ */ React__default.createElement("div", { className: "nav-item back" }, /* @__PURE__ */ React__default.createElement("span", null, "‹")), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item title" }, /* @__PURE__ */ React__default.createElement("span", null, "Timeline")), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item menu" }, /* @__PURE__ */ React__default.createElement("span", null))), /* @__PURE__ */ React__default.createElement("div", { className: "app-view" }, /* @__PURE__ */ React__default.createElement("div", { className: "view-header" }, "Daily Articles Overview"), /* @__PURE__ */ React__default.createElement("div", { className: "day-selection" }, /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Sun"), /* @__PURE__ */ React__default.createElement("span", null, "12")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Mon"), /* @__PURE__ */ React__default.createElement("span", null, "13")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Tue"), /* @__PURE__ */ React__default.createElement("span", null, "14")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Wed"), /* @__PURE__ */ React__default.createElement("span", null, "15")), /* @__PURE__ */ React__default.createElement("div", { className: "selected" }, /* @__PURE__ */ React__default.createElement("span", null, "Thu"), /* @__PURE__ */ React__default.createElement("span", null, "16")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Fri"), /* @__PURE__ */ React__default.createElement("span", null, "17")), /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement("span", null, "Sat"), /* @__PURE__ */ React__default.createElement("span", null, "18"))), /* @__PURE__ */ React__default.createElement("div", { className: "card" }, /* @__PURE__ */ React__default.createElement("div", { className: "top" }, /* @__PURE__ */ React__default.createElement("div", { className: "tag" }, /* @__PURE__ */ React__default.createElement("span", { className: "clicks" }, "12,904K")), /* @__PURE__ */ React__default.createElement("div", { className: "space" }), /* @__PURE__ */ React__default.createElement("div", { className: "tag" }, /* @__PURE__ */ React__default.createElement("span", { className: "xshare" }, "<"))), /* @__PURE__ */ React__default.createElement("div", { className: "mid-upper" }, /* @__PURE__ */ React__default.createElement("div", { className: "title" }, "Upcoming Event Drives Engagement Spike")), /* @__PURE__ */ React__default.createElement("div", { className: "mid-lower" }, /* @__PURE__ */ React__default.createElement("div", { className: "author" }, "Breaking")), /* @__PURE__ */ React__default.createElement("div", { className: "bottom" }, /* @__PURE__ */ React__default.createElement("div", { className: "author-icon" }, "AH"), /* @__PURE__ */ React__default.createElement("div", { className: "space" }))), /* @__PURE__ */ React__default.createElement("div", { className: "card" }, /* @__PURE__ */ React__default.createElement("div", { className: "top" }, /* @__PURE__ */ React__default.createElement("div", { className: "tag" }, /* @__PURE__ */ React__default.createElement("span", { className: "clicks" }, "10,590K")), /* @__PURE__ */ React__default.createElement("div", { className: "space" }), /* @__PURE__ */ React__default.createElement("div", { className: "tag" }, /* @__PURE__ */ React__default.createElement("span", { className: "share" }, "<"))), /* @__PURE__ */ React__default.createElement("div", { className: "mid-upper" }, /* @__PURE__ */ React__default.createElement("div", { className: "title" }, "Looking Ahead to the Next Big Thing!")), /* @__PURE__ */ React__default.createElement("div", { className: "mid-lower" }, /* @__PURE__ */ React__default.createElement("div", { className: "author" }, "Breaking")), /* @__PURE__ */ React__default.createElement("div", { className: "bottom" }, /* @__PURE__ */ React__default.createElement("div", { className: "author-icon" }, "AH"), /* @__PURE__ */ React__default.createElement("div", { className: "space" })))), /* @__PURE__ */ React__default.createElement("div", { className: "nav-bar bottom" }, /* @__PURE__ */ React__default.createElement("div", { className: "nav-item icon" }), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item icon" }), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item icon primary" }), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item icon" }), /* @__PURE__ */ React__default.createElement("div", { className: "nav-item icon" })))), /* @__PURE__ */ React__default.createElement("div", { className: "android-top-bar" }), /* @__PURE__ */ React__default.createElement("div", { className: "notch" }), /* @__PURE__ */ React__default.createElement("div", { className: "status-bar-left" }, /* @__PURE__ */ React__default.createElement("div", { className: "time" }, /* @__PURE__ */ React__default.createElement("span", { id: "clock", className: "value" }, format(statusTime, "H:mm")))), /* @__PURE__ */ React__default.createElement("div", { className: "status-bar-right" }, /* @__PURE__ */ React__default.createElement("div", { className: "signal" }, /* @__PURE__ */ React__default.createElement("div", { className: "bars" }, /* @__PURE__ */ React__default.createElement("div", { className: "bar" }), /* @__PURE__ */ React__default.createElement("div", { className: "bar" }), /* @__PURE__ */ React__default.createElement("div", { className: "bar" }), /* @__PURE__ */ React__default.createElement("div", { className: "bar bad" })), /* @__PURE__ */ React__default.createElement("div", { className: "type" }, "5G")), /* @__PURE__ */ React__default.createElement("div", { className: "battery" })));
};
const NativeIosNotification = (props) => {
  var _a;
  const colorScheme = (_a = props.config.systemMode) != null ? _a : "light";
  const config = props.config;
  const notification = config.notification;
  const isExpandedView = config.state === PreviewState.EXPANDED;
  const actions = notification.actions;
  const SettingsAction = {
    action: "settings",
    title: "Settings"
  };
  if (actions && !actions.find((action) => action.action === "settings")) {
    actions.push(SettingsAction);
  }
  let image = notification.image;
  let imageClass = "";
  if (image) {
    image = encodeURI(image);
    imageClass = "has-image";
  }
  const previewStateClassName = isExpandedView ? "expanded" : "collapsed";
  const assignColorScheme = (classnames2) => {
    return `${classnames2} ${colorScheme}`;
  };
  const Wrapper = props.config.chromeless ? ({ children }) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children) : NativeDeviceWrapper;
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames("notification-ios-preview-wrapper", colorScheme, previewStateClassName) }, /* @__PURE__ */ React__default.createElement(
    Wrapper,
    {
      loading: props.config.loading,
      view: DeviceView.LOCK_SCREEN,
      channel: deliveryChannels_enum.DeliveryChannel.NATIVE_IOS,
      orientation: "portrait",
      systemMode: colorScheme,
      useDynamicIsland: true
    },
    /* @__PURE__ */ React__default.createElement("div", { className: `notification-shell flex-col ${colorScheme} ${previewStateClassName}` }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-upper flex-row" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-left flex-col" }, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: "notification-app-icon",
        style: { backgroundImage: `url("${notification.icon}")` }
      }
    )), /* @__PURE__ */ React__default.createElement("div", { className: "notification-right flex-row" }, /* @__PURE__ */ React__default.createElement("div", { className: `notification-content-left flex-col ${previewStateClassName} ${imageClass}` }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-title" }, notification.title), notification.subtitle && /* @__PURE__ */ React__default.createElement("div", { className: "notification-subtitle" }, notification.subtitle), notification.body && /* @__PURE__ */ React__default.createElement("div", { className: "notification-body" }, notification.body)), /* @__PURE__ */ React__default.createElement("div", { className: "notification-content-right flex-col" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-timestamp" }, "now"), !isExpandedView && image && /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: "notification-image-small",
        style: { backgroundImage: `url("${image}")` }
      }
    )))), isExpandedView && image && /* @__PURE__ */ React__default.createElement("div", { className: "notification-lower flex-row" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-image-large flex-row" }, /* @__PURE__ */ React__default.createElement("img", { src: image, alt: image })))),
    actions && isExpandedView && /* @__PURE__ */ React__default.createElement("div", { className: assignColorScheme("actions-wrapper has-actions") }, /* @__PURE__ */ React__default.createElement("ul", null, actions == null ? void 0 : actions.map((action, idx) => /* @__PURE__ */ React__default.createElement("li", { key: idx, className: "action-btn" }, /* @__PURE__ */ React__default.createElement("span", { className: "action-btn-title" }, action.title)))))
  ));
};
const androidDefaultSmallIcon = "data:image/png;base64,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";
const AndroidNotification = (props) => {
  var _a, _b, _c;
  const config = props.config;
  const notification = config.notification;
  const platformIsNative = config.platform === Platform.NATIVE_ANDROID;
  const isExpandedView = config.state === PreviewState.EXPANDED;
  const actions = (_a = notification.actions) != null ? _a : [];
  let badge = (_b = notification.badge) != null ? _b : androidDefaultSmallIcon;
  let badgeColor = (_c = notification.badgeColor) != null ? _c : "gray";
  if (!platformIsNative) {
    badge = BrowserIcon[config.browser];
    badgeColor = "gray";
  }
  let image = notification.image;
  let imageClass = "";
  if (image) {
    image = encodeURI(image);
    imageClass = "large-icon";
  }
  let largeIcon = notification.icon;
  if (image && (!largeIcon || notification.useImageForIconWhenPresent)) {
    largeIcon = image;
  }
  if (image && notification.useImageForIconWhenPresent && isExpandedView) {
    largeIcon = void 0;
  }
  if (largeIcon) {
    imageClass = "large-icon";
  }
  const previewStateClassName = isExpandedView ? "expanded" : "collapsed";
  const appName = platformIsNative ? config.appName : config.notification.domain;
  const browser = config.browser.charAt(0).toUpperCase() + config.browser.slice(1);
  const SettingsAction = {
    action: "settings",
    title: "Site settings"
  };
  let displayActions = [...actions];
  if (!platformIsNative && (!!displayActions && displayActions.length > 0)) {
    displayActions.push(SettingsAction);
  }
  const Wrapper = props.config.chromeless ? ({ children }) => /* @__PURE__ */ React__default.createElement("div", { className: `notification-native-android-preview-wrapper ${previewStateClassName}` }, children) : NativeDeviceWrapper;
  return /* @__PURE__ */ React__default.createElement(
    Wrapper,
    {
      className: `notification-native-android-preview-wrapper ${previewStateClassName}`,
      loading: props.config.loading,
      view: DeviceView.LOCK_SCREEN,
      channel: deliveryChannels_enum.DeliveryChannel.NATIVE_ANDROID,
      orientation: "portrait",
      systemMode: "light"
    },
    /* @__PURE__ */ React__default.createElement("div", { className: "notifications-container" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-shell flex-col" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-upper flex-row" }, /* @__PURE__ */ React__default.createElement("div", { className: `flex-col notification-left ${previewStateClassName}` }, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: "img-wrapper",
        style: { backgroundColor: badgeColor }
      },
      /* @__PURE__ */ React__default.createElement(
        "img",
        {
          className: "notification-small-icon",
          src: badge
        }
      )
    )), /* @__PURE__ */ React__default.createElement("div", { className: "notification-middle flex-row" }, /* @__PURE__ */ React__default.createElement("div", { className: `notification-content-left ${previewStateClassName} ${imageClass}` }, !isExpandedView ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("ul", { className: "in-line flex-row" }, /* @__PURE__ */ React__default.createElement("li", { className: "notification-title" }, notification.title), !platformIsNative && isExpandedView && /* @__PURE__ */ React__default.createElement("li", { className: "notification-domain" }, appName), /* @__PURE__ */ React__default.createElement("li", { className: "notification-timestamp" }, "now"))) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("ul", { className: "top-line flex-row" }, /* @__PURE__ */ React__default.createElement("li", { className: "app-name" }, platformIsNative ? appName : browser), platformIsNative ? notification.subtitle ? /* @__PURE__ */ React__default.createElement("li", { className: "notification-subtext" }, notification.subtitle) : null : /* @__PURE__ */ React__default.createElement("li", { className: "notification-domain" }, appName), /* @__PURE__ */ React__default.createElement("li", { className: "notification-timestamp" }, "now")), /* @__PURE__ */ React__default.createElement("div", { className: "notification-title" }, notification.title)), notification.body && /* @__PURE__ */ React__default.createElement("div", { className: "notification-body" }, notification.body)), /* @__PURE__ */ React__default.createElement("div", { className: `notification-content-right ${previewStateClassName}` }, largeIcon && /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: "notification-large-icon",
        style: { backgroundImage: `url("${largeIcon}")` }
      }
    ))), /* @__PURE__ */ React__default.createElement("div", { className: `notification-right flex-col ${previewStateClassName}` }, /* @__PURE__ */ React__default.createElement("div", { className: "expand-icon" }, /* @__PURE__ */ React__default.createElement("i", { className: "arrow" })))), image && isExpandedView && /* @__PURE__ */ React__default.createElement("div", { className: "notification-content-expanded-big-picture" }, /* @__PURE__ */ React__default.createElement("div", { className: "notification-big-picture" }, /* @__PURE__ */ React__default.createElement("img", { src: image, alt: "image" }))), /* @__PURE__ */ React__default.createElement("div", { className: "notification-content-lower-actions" }, actions && /* @__PURE__ */ React__default.createElement("div", { className: `actions-wrapper has-actions ${previewStateClassName}` }, /* @__PURE__ */ React__default.createElement("ul", null, displayActions == null ? void 0 : displayActions.map((action, idx) => /* @__PURE__ */ React__default.createElement("li", { key: idx, className: "action-btn" }, /* @__PURE__ */ React__default.createElement("span", { className: "action-btn-title" }, action.title))))))))
  );
};
const coalesce = (value, defaultValue) => {
  return value === null || value === void 0 ? defaultValue : value;
};
const PreviewAbstract = (props) => {
  var _a;
  const [state, setState] = useState(() => ({
    config: new PreviewConfig(props.config)
  }));
  useEffect(() => {
    setState(() => ({
      config: new PreviewConfig(props.config)
    }));
  }, [
    props.config.loading,
    props.config.platform,
    props.config.state,
    props.config.browser,
    props.config.chromeless,
    props.config.notification,
    props.config.animated,
    props.config.loggingEnabled,
    props.config.useEnv,
    props.config.systemMode
  ]);
  state.config.platform = coalesce(state.config.platform, Platform.ANDROID);
  state.config.state = coalesce(state.config.state, PreviewState.COLLAPSED);
  const platform = state.config.platform.toLowerCase();
  const getPreviewComponent = (platform2) => {
    switch (platform2) {
      default:
      case Platform.MAC_OS:
        return /* @__PURE__ */ React__default.createElement(MacOsTemplate, { config: state.config });
      case Platform.IOS:
        return /* @__PURE__ */ React__default.createElement(NativeIosNotification, { config: state.config });
      case Platform.WINDOWS:
        return /* @__PURE__ */ React__default.createElement(WindowsTemplate, { config: state.config });
      case Platform.ANDROID:
      case Platform.NATIVE_ANDROID:
        return /* @__PURE__ */ React__default.createElement(AndroidNotification, { config: state.config });
    }
  };
  try {
    state.config.validate();
  } catch (error) {
    if (error && typeof error === "object") {
      return /* @__PURE__ */ React__default.createElement(PreviewDock, { classNames: [platform] }, /* @__PURE__ */ React__default.createElement("span", { className: "error" }, (_a = error.message) != null ? _a : error));
    }
  }
  return /* @__PURE__ */ React__default.createElement(PreviewDock, { classNames: [platform] }, getPreviewComponent(platform));
};
var appMessageTemplateStyle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.AppMessageTemplateStyle = void 0;
  (function(AppMessageTemplateStyle) {
    AppMessageTemplateStyle["MODAL"] = "MODAL";
    AppMessageTemplateStyle["BANNER"] = "BANNER";
    AppMessageTemplateStyle["FULLSCREEN"] = "FULLSCREEN";
    AppMessageTemplateStyle["CUSTOM"] = "CUSTOM";
  })(exports.AppMessageTemplateStyle || (exports.AppMessageTemplateStyle = {}));
})(appMessageTemplateStyle);
var position = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Position = void 0;
  (function(Position) {
    Position["TOP"] = "TOP";
    Position["BOTTOM"] = "BOTTOM";
    Position["LEFT"] = "LEFT";
    Position["RIGHT"] = "RIGHT";
    Position["BACKGROUND"] = "BACKGROUND";
  })(exports.Position || (exports.Position = {}));
})(position);
const contentFgColor = (content) => {
  var _a;
  return (_a = content.fgColor) != null ? _a : "#000000";
};
const contentBgColor = (content) => {
  var _a;
  return (_a = content.bgColor) != null ? _a : "#FFFFFF";
};
const AppMessageImage = ({ orientation, template: { image }, container }) => {
  var _a;
  const [prevSource, setPrevSource] = useState();
  const [dims, setDims] = useState();
  function setImageDims(bounds, width, height) {
    const minBound = Math.min(bounds.width, bounds.height);
    const ratio = Math.min(minBound, width) / Math.max(minBound, width);
    setDims({
      width: Math.floor(width * ratio),
      height: Math.floor(height * ratio)
    });
  }
  useEffect(() => {
    if (!container.current) {
      console.warn("[CF] App Message preview container not available");
      return;
    }
    const appMessageContainer = container.current;
    if (!image.source && prevSource) {
      setPrevSource(void 0);
      setDims(void 0);
    } else if (image.source && (!prevSource || image.source !== prevSource)) {
      const bounds = appMessageContainer.getBoundingClientRect();
      const shadow = new Image();
      shadow.onload = function onImageLoad() {
        setPrevSource(image.source);
        setImageDims(bounds, this.width, this.height);
      };
      shadow.src = image.source;
    }
  }, [(_a = container.current) == null ? void 0 : _a.id, prevSource, image.source]);
  const imgStyle = {
    backgroundImage: `url(${image.source})`,
    backgroundSize: image.size
  };
  if (dims && dims.width) {
    if (orientation === "landscape") {
      imgStyle.width = dims.width;
    } else {
      imgStyle.height = dims.height;
    }
  }
  return !image.enabled ? null : /* @__PURE__ */ React__default.createElement(
    "div",
    {
      id: "pushly-iam-img",
      className: "rounded",
      style: imgStyle
    }
  );
};
const IamCloseIcon = React.memo(() => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 512 512",
      id: "iam-close-icon",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("g", { transform: "translate(-299.05432,-867.57239)" }, /* @__PURE__ */ React.createElement(
      "circle",
      {
        style: {
          fill: "#fbfbfb",
          fillOpacity: 1,
          stroke: "#3d3d3d",
          strokeWidth: 2.75622,
          strokeDasharray: "none",
          strokeOpacity: 1
        },
        id: "iam-icon-close-circle",
        cx: "555.05432",
        cy: "1123.5724",
        r: "254.62189"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        style: {
          fill: "#3d3d3d",
          fillOpacity: 1,
          stroke: "#3d3d3d",
          strokeWidth: 22.0498,
          strokeDasharray: "none",
          strokeOpacity: 1
        },
        id: "iam-close-icon-x",
        d: "m 460.76677,1001.1079 c -5.90696,-0.1372 -11.86722,1.9893 -16.49857,6.4104 -9.2627,8.8422 -9.60122,23.4178 -0.75904,32.6805 l 79.58915,83.3736 -79.58916,83.3736 c -8.84219,9.2627 -8.50365,23.8384 0.75906,32.6806 9.26269,8.8422 23.83841,8.5037 32.68059,-0.7591 l 78.10551,-81.8199 78.10552,81.8199 c 8.84218,9.2628 23.4179,9.6013 32.68063,0.7592 9.26269,-8.8423 9.6012,-23.418 0.759,-32.6807 l -79.58911,-83.3736 79.58912,-83.3736 c 8.84219,-9.2627 8.50369,-23.8383 -0.75903,-32.6805 -9.26269,-8.84222 -23.83844,-8.50372 -32.68062,0.759 l -78.10551,81.8199 -78.10548,-81.8199 c -4.42111,-4.6314 -10.27509,-7.0322 -16.18206,-7.1694 z"
      }
    ))
  );
});
const AppMessageCloseButton = ({ template: { showCloseAction } }) => {
  return !showCloseAction ? null : /* @__PURE__ */ React__default.createElement("div", { className: "show-close-action" }, /* @__PURE__ */ React__default.createElement(IamCloseIcon, null));
};
const AppMessageContent = (props) => {
  var _a;
  const { template } = props;
  const { header, title, body } = template;
  return /* @__PURE__ */ React__default.createElement("div", { id: "pushly-iam-content" }, header.enabled && /* @__PURE__ */ React__default.createElement("div", { id: "pushly-iam-header", style: {
    color: contentFgColor(header)
  } }, header.value), title.enabled && /* @__PURE__ */ React__default.createElement("div", { id: "pushly-iam-title", style: {
    color: contentFgColor(title)
  } }, title.value), body.enabled && /* @__PURE__ */ React__default.createElement("div", { id: "pushly-iam-body", style: {
    color: contentFgColor(body)
  }, dangerouslySetInnerHTML: { __html: (_a = body.value) != null ? _a : "" } }));
};
var layoutOrientation = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.LayoutOrientation = void 0;
  (function(LayoutOrientation) {
    LayoutOrientation["HORIZONTAL"] = "HORIZONTAL";
    LayoutOrientation["VERTICAL"] = "VERTICAL";
  })(exports.LayoutOrientation || (exports.LayoutOrientation = {}));
})(layoutOrientation);
var appMessageActionStyle = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.AppMessageActionStyle = void 0;
  (function(AppMessageActionStyle) {
    AppMessageActionStyle["TAB"] = "TAB";
    AppMessageActionStyle["CIRCLE"] = "CIRCLE";
  })(exports.AppMessageActionStyle || (exports.AppMessageActionStyle = {}));
})(appMessageActionStyle);
const AppMessageButton = ({ type, config, className }) => {
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      id: `pushly-iam-btn-${type}`,
      className: classNames(className),
      style: { backgroundColor: contentBgColor(config) }
    },
    /* @__PURE__ */ React__default.createElement("span", { style: {
      color: contentFgColor(config)
    } }, config.label)
  );
};
const AppMessageButtons = (props) => {
  const { template } = props;
  const { ctaLayout, ctaPrimary, ctaSecondary } = template;
  let displayCtaPrimary = ctaPrimary;
  const isBannerStyle = template.style === appMessageTemplateStyle.AppMessageTemplateStyle.BANNER;
  if (isBannerStyle && ctaPrimary.enabled) {
    displayCtaPrimary = ctaPrimary.clone({ label: "›" });
  }
  return /* @__PURE__ */ React__default.createElement("div", { id: "pushly-iam-btns", className: classNames({
    ["cta-layout-vertical"]: ctaLayout === layoutOrientation.LayoutOrientation.VERTICAL,
    ["cta-layout-horizontal"]: ctaLayout === layoutOrientation.LayoutOrientation.HORIZONTAL,
    "tab": isBannerStyle && ctaPrimary.style === appMessageActionStyle.AppMessageActionStyle.TAB,
    "circle": isBannerStyle && ctaPrimary.style === appMessageActionStyle.AppMessageActionStyle.CIRCLE
  }) }, ctaPrimary.enabled && /* @__PURE__ */ React__default.createElement(AppMessageButton, { type: "primary", config: displayCtaPrimary }), ctaSecondary.enabled && /* @__PURE__ */ React__default.createElement(AppMessageButton, { type: "secondary", config: ctaSecondary }));
};
const AppMessageMain = ({ template }) => {
  const { image, style } = template;
  const isFullscreen = style === appMessageTemplateStyle.AppMessageTemplateStyle.FULLSCREEN;
  const isImageBottom = image.enabled && image.position === position.Position.BOTTOM;
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      id: "pushly-iam-main",
      className: classNames({
        "content-top": isFullscreen && isImageBottom
      })
    },
    /* @__PURE__ */ React__default.createElement(AppMessageContent, { template }),
    /* @__PURE__ */ React__default.createElement(AppMessageButtons, { template })
  );
};
var appMessageImageSize = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.AppMessageImageSize = void 0;
  (function(AppMessageImageSize) {
    AppMessageImageSize["COVER"] = "COVER";
    AppMessageImageSize["CONTAIN"] = "CONTAIN";
  })(exports.AppMessageImageSize || (exports.AppMessageImageSize = {}));
})(appMessageImageSize);
const AppMessageView = (props) => {
  var _a;
  const { orientation, template } = props;
  const { image, style, bannerPosition } = template;
  const isModal = style === appMessageTemplateStyle.AppMessageTemplateStyle.MODAL;
  const isBanner = style === appMessageTemplateStyle.AppMessageTemplateStyle.BANNER;
  const isFullscreen = style === appMessageTemplateStyle.AppMessageTemplateStyle.FULLSCREEN;
  const isImageBg = image.enabled && image.position === position.Position.BACKGROUND;
  const isImageBottom = image.position === position.Position.BOTTOM;
  const containerStyle = {};
  if (isImageBg) {
    containerStyle.backgroundImage = `url("${image.source}")`;
    containerStyle.backgroundPosition = "center";
    containerStyle.backgroundSize = (_a = image.size) != null ? _a : appMessageImageSize.AppMessageImageSize.COVER;
    containerStyle.backgroundRepeat = "no-repeat";
  }
  const ref = useRef();
  const deviceType = props.channel === deliveryChannels_enum.DeliveryChannel.WEB ? "d-web" : "d-phone";
  return /* @__PURE__ */ React__default.createElement("div", { id: "app-message-view", className: classNames(deviceType, `o-${orientation}`, {
    "s-modal": isModal,
    "s-banner": isBanner,
    "s-fullscreen": isFullscreen,
    "banner-top": (bannerPosition == null ? void 0 : bannerPosition.mobile) === position.Position.TOP,
    "banner-bottom": (bannerPosition == null ? void 0 : bannerPosition.mobile) === position.Position.BOTTOM
  }) }, /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: (el) => ref.current = el != null ? el : void 0,
      id: "push-sdk-am-container",
      className: classNames({
        "image-bottom": !isImageBg && !isBanner && isImageBottom,
        "image-right": !isImageBg && isBanner && image.position === position.Position.RIGHT
      }),
      style: __spreadValues({
        backgroundColor: contentBgColor(template)
      }, containerStyle)
    },
    /* @__PURE__ */ React__default.createElement(AppMessageCloseButton, { template }),
    !isImageBg && /* @__PURE__ */ React__default.createElement(AppMessageImage, { template, container: ref, orientation }),
    /* @__PURE__ */ React__default.createElement(AppMessageMain, { template })
  ));
};
const AppMessagePortrait = (props) => {
  var _a, _b;
  const { template, loading, useDynamicIsland, channel } = props;
  const systemMode = (_a = props.systemMode) != null ? _a : "dark";
  const orientation = (_b = props.orientation) != null ? _b : "portrait";
  const isModal = props.template.style === appMessageTemplateStyle.AppMessageTemplateStyle.MODAL;
  const Wrapper = props.channel === deliveryChannels_enum.DeliveryChannel.WEB ? (props2) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, props2.children) : NativeDeviceWrapper;
  return /* @__PURE__ */ React__default.createElement(
    Wrapper,
    {
      className: template.style.toLowerCase(),
      loading,
      orientation,
      channel,
      systemMode,
      useDynamicIsland
    },
    /* @__PURE__ */ React__default.createElement("div", { className: classNames("content", template.style.toLowerCase(), {
      ["modal-focus"]: isModal != null ? isModal : false
    }) }, /* @__PURE__ */ React__default.createElement(
      AppMessageView,
      {
        channel,
        template,
        orientation
      }
    ))
  );
};
const _Cuttlefish = class _Cuttlefish {
  static get Preview() {
    return PreviewAbstract;
  }
  static get NotificationPreview() {
    return PreviewAbstract;
  }
  static get AppMessagePreview() {
    return AppMessagePortrait;
  }
  static init(options) {
    return __async(this, null, function* () {
      _Cuttlefish.boot();
      if (options && options.containerId) {
        AppContext.current.containerId = options.containerId;
      }
      if (_Cuttlefish.initialized) {
        console.warn("Already initialized");
        return;
      } else {
        _Cuttlefish.initialized = true;
      }
      yield _Cuttlefish.reloadDock();
    });
  }
  static preview(config) {
    return __async(this, null, function* () {
      try {
        yield _Cuttlefish.resetDock(config);
        _Cuttlefish.reloadDock(config.platform, /* @__PURE__ */ React__default.createElement(PreviewAbstract, { config }));
      } catch (error) {
        console.error(error);
      }
    });
  }
  static boot() {
    AppContext.init(_Cuttlefish.version);
  }
  static resetDock(config) {
    return __async(this, null, function* () {
      return new Promise((resolve) => {
        _Cuttlefish.reloadDock(config.platform, /* @__PURE__ */ React__default.createElement("span", null));
        setTimeout(resolve, 240);
      });
    });
  }
  static reloadDock(platform, preview) {
    ReactDOM.render(
      /* @__PURE__ */ React__default.createElement(PreviewDock, { classNames: [platform] }, preview),
      AppContext.current.container
    );
  }
};
__publicField(_Cuttlefish, "version", Version.v201805);
__publicField(_Cuttlefish, "initialized", false);
let Cuttlefish = _Cuttlefish;
window.PushlyPreviewSDK = Cuttlefish;
export {
  Browser,
  Platform,
  PreviewState,
  Cuttlefish as default
};
